import { createAnimation } from './createAnimation';

let scrollLockTop = 0;
let scrollLockLeft = 0;
let scrollLocked = false;

// Make scroll event void
function revertScroll() {
	// Can't use preventDefault, as it doesn't work
	// Just lock scrolling to initial position
	scrollTo(scrollLockLeft, scrollLockTop);
}

/* Lock main page scrolling */
export function lockPageScroll() {
	// Remember current scroll position
	scrollLockTop = window.scrollY;
	scrollLockLeft = window.scrollX;
	// Only bind the event listener once
	if (scrollLocked) { return; }
	// Add event handler to catch all scroll events
	document.addEventListener('scroll', revertScroll);
	// Set status flag
	scrollLocked = true;
}

/* Unlock main page scrolling */
export function unlockPageScroll() {
	// Only unbind the event listener once
	if (!scrollLocked) { return; }
	// Remove event handler to catch all scroll events
	document.removeEventListener('scroll', revertScroll);
	// Set status flag
	scrollLocked = false;
}


let smoothScrollingSupported : boolean | undefined;
function supportsSmoothScrolling() {

	if(smoothScrollingSupported !== undefined) {
		return smoothScrollingSupported;
	}

	smoothScrollingSupported = false;

	try {
		const div = document.createElement('div');
		div.scrollTo({
			get behavior() : 'smooth' {
				smoothScrollingSupported = true;

				return 'smooth';
			},
			top: 0,
		});
	} catch (err) {} // Edge throws an error

	return smoothScrollingSupported;
}

/**
 * Smoothely scroll a desired Element on the page into view.
 * @param node the HTMLElement to scroll to.
 * @param forcePolyfill Force polyfill for testing purpose only.
 */
export function smoothScrollIntoView(nodeOrSelector : HTMLElement | string, forcePolyfill = false) {
	const node = (typeof nodeOrSelector === 'string') ? document.querySelector(nodeOrSelector) : nodeOrSelector;

	if(node === null) {
		return;
	}

	if (supportsSmoothScrolling() && !forcePolyfill) {
		node.scrollIntoView({
			behavior: 'smooth',
		});

		return;
	}

	const animation = createAnimation({
		animator(_t, val) {
			node.ownerDocument.documentElement.scrollTop = val;
		},
		easing: 'swing',
		endValue: node.getBoundingClientRect().top,
		startValue: node.ownerDocument.documentElement.scrollTop,
	});

	function cancel() {
		animation.stop(false);
	}

	animation.start({
		callback() {
			node.removeEventListener('wheel', cancel);
			node.removeEventListener('touchstart', cancel);
		},
	});

	node.addEventListener('wheel', cancel, { passive: true });
	node.addEventListener('touchstart', cancel, { passive: true });
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/pageScrolling.ts